var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1548_1946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9459 1.02871C24.0005 0.892413 24.0138 0.743103 23.9843 0.599288C23.9548 0.455474 23.8838 0.32348 23.7799 0.21967C23.6761 0.11586 23.5441 0.0448002 23.4003 0.015299C23.2565 -0.0142021 23.1072 -0.000846891 22.9709 0.0537091L1.1504 8.78221H1.1489L0.470904 9.05221C0.342489 9.10343 0.230732 9.18915 0.147977 9.2999C0.0652226 9.41066 0.0146909 9.54213 0.00196413 9.67979C-0.0107627 9.81746 0.0148107 9.95597 0.0758594 10.08C0.136908 10.2041 0.231056 10.3088 0.347904 10.3827L0.962904 10.7727L0.964404 10.7757L8.4569 15.5427L13.2239 23.0352L13.2269 23.0382L13.6169 23.6532C13.691 23.7696 13.7959 23.8633 13.9198 23.924C14.0438 23.9846 14.182 24.0099 14.3194 23.997C14.4568 23.9842 14.588 23.9336 14.6986 23.851C14.8091 23.7684 14.8947 23.6569 14.9459 23.5287L23.9459 1.02871ZM21.1964 3.86371L9.9554 15.1047L9.6329 14.5977C9.57381 14.5047 9.49494 14.4258 9.4019 14.3667L8.8949 14.0442L20.1359 2.80321L21.9029 2.09671L21.1964 3.86371Z",
    fill: "#16304F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1548_1946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send-icon.6e6e9719d064f231d62d29e127f9590b.svg";
export { ForwardRef as ReactComponent };